var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
import { Unit } from 'packages/users/Unit';
import { asset } from 'packages/media/util';
var User = /** @class */ (function (_super) {
    __extends(User, _super);
    function User() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.name = null;
        _this.email = null;
        _this.language = null;
        _this.cityId = null;
        _this.source = null;
        _this.profileImage = null;
        _this.avatar = null;
        _this.createdAt = null;
        _this.lastSeen = null;
        _this.role = null;
        _this.setupCompleted = false;
        _this.setupCompletedAt = null;
        _this.isInvitationExpired = false;
        _this.hubspotId = null;
        _this.unit = null;
        return _this;
    }
    User.prototype.getAvatarResized = function (width, height, fm) {
        var _a;
        if (fm === void 0) { fm = 'webp'; }
        if ((_a = this.profileImage) === null || _a === void 0 ? void 0 : _a.includes('default.jpg')) {
            return null;
        }
        if (this.profileImage) {
            var options = { fm: fm, width: width };
            if (height) {
                options = __assign(__assign({}, options), { height: height });
            }
            return asset(this.profileImage, options);
        }
        return null;
    };
    Object.defineProperty(User.prototype, "displayName", {
        get: function () {
            var _a;
            return (_a = this.name) !== null && _a !== void 0 ? _a : this.email;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "joinedAt", {
        // JDS5 Nametag requires setupCompletedAt field to be joinedAt, isPendingInvite and isExpiredInvite are also JDS-related
        get: function () {
            return this.setupCompletedAt;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isPendingInvite", {
        get: function () {
            return !this.isInvitationExpired && !this.setupCompletedAt;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isExpiredInvite", {
        get: function () {
            return this.isInvitationExpired;
        },
        enumerable: false,
        configurable: true
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    User.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        this.avatar = this.getAvatarResized(200, 200);
        return this;
    };
    var _a;
    __decorate([
        Type(Unit),
        __metadata("design:type", typeof (_a = typeof Unit !== "undefined" && Unit) === "function" ? _a : Object)
    ], User.prototype, "unit", void 0);
    return User;
}(Entity));
export { User };
